'use client';

import { useAuth } from 'react-oidc-context';
import styled from 'styled-components';

import { Clock, Mug, Setting } from '@zoomit/icons';
import { Link } from '@zoomit/primitives';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { OriginURL } from '../../constants/apis';
import { onActivitiesClick, onMyZoomitClick, onSettingsClick } from '../../helpers/events';
import { useWebKitCustomization } from '../../hooks/useWebKitCustomization';

type Props = {
  isAuthor: boolean;
};

const ProfileLinksDesktop = (props: Props) => {
  const { isAuthor } = props;

  const { user } = useAuth();
  const userId = user?.profile.sub;

  const tenantPersianTitle = useWebKitCustomization((config) => config.tenantPersianTitle);

  return (
    <>
      <Link href={`${OriginURL}/${isAuthor ? 'author' : 'profile'}/${userId}/`} onClick={onMyZoomitClick}>
        <ProfileActionButton>
          <Mug size="md" fill={cssVar(theme.grey1)} />
          <Typography fontSize={1.4} lineHeight={1.8}>{`${tenantPersianTitle} من`}</Typography>
        </ProfileActionButton>
      </Link>
      <Link
        href={`${OriginURL}/${isAuthor ? 'author' : 'profile'}/${userId}/activities/?tab=reads`}
        onClick={onActivitiesClick}
      >
        <ProfileActionButton>
          <Clock size="md" fill={cssVar(theme.grey1)} />
          <Typography fontSize={1.4} lineHeight={1.8}>
            فعالیت‌ها
          </Typography>
        </ProfileActionButton>
      </Link>
      <Link
        href={`${OriginURL}/${isAuthor ? 'author' : 'profile'}/${userId}/settings/?form=userInfo`}
        onClick={onSettingsClick}
      >
        <ProfileActionButton>
          <Setting size="md" fill={cssVar(theme.grey1)} />
          <Typography fontSize={1.4} lineHeight={1.8}>
            تنظیمات
          </Typography>
        </ProfileActionButton>
      </Link>
    </>
  );
};

export default ProfileLinksDesktop;

const ProfileActionButton = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.8rem;
`;
